import { Controller, useFieldArray } from 'react-hook-form';
import Input from 'src/components/Input/Input';
import React from 'react';
import { clsx } from 'clsx';
import { WorkflowEscalatedList } from 'src/pages/ConfigurationPage/WorkflowsTab/WorkflowPopupBock/WorkflowEscalatedList/WorkflowEscalatedList';
import { WorkflowActionsSelect } from 'src/pages/ConfigurationPage/WorkflowsTab/WorkflowPopupBock/WorkflowActionsSelect/WorkflowActionsSelect';
import { WORKFLOWS_ACTION_MESSAGES_TYPES } from 'src/pages/ConfigurationPage/WorkflowsTab/constants';
import { Button } from 'src/components/ui/button';

const RemoveActionIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
  >
    <path
      className={'group-hover:fill-[#3626aa]'}
      d="M1.04405 17.1001V2.93343H0.0996094V1.04454H4.82183V0.100098H10.4885V1.04454H15.2107V2.93343H14.2663V17.1001H1.04405ZM2.93294 15.2112H12.3774V2.93343H2.93294V15.2112ZM4.82183 13.3223H6.71072V4.82232H4.82183V13.3223ZM8.59961 13.3223H10.4885V4.82232H8.59961V13.3223Z"
      fill="#7A6BE5"
      stroke="white"
      strokeWidth="0.2"
    />
  </svg>
);

export const WorkflowActionsBlock = ({ control, watch, trigger = () => {}, isCustom = true }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'action',
  });

  const addAction = () => {
    append({
      action_type: 'clarify',
      action_fields_custom: false,
      action_message_type: 'transcript',
      action_message: '',
      action_escalated_list: '',
      action_data_collection: '',
      message_before: '',
      message_after: '',
      message_close: '',
    });
  };

  const removeAction = (index) => {
    remove(index);
  };

  return (
    <div className={'flex flex-col gap-5'}>
      {isCustom && (
        <div className={'flex flex-row justify-between items-center'}>
          <div>
            <p className={'text-sm text-ebony_opacity_80 font-semibold'}>Action</p>
          </div>
        </div>
      )}
      {fields.map((field, index) => {
        const actionType = watch(`action.${index}.action_type`);

        return (
          <div key={field.id} className={'flex w-full flex-col gap-1.5'}>
            {isCustom && (
              <div className={'flex flex-col w-full items-center gap-1.5 relative'}>
                <div
                  className={'absolute left-5 top-1/4 w-2.5 text-[#7A6BE5] text-sm font-semibold'}
                >
                  {index + 1}.
                </div>
                <div className={'w-[84%]'}>
                  <WorkflowActionsSelect
                    name={`action.${index}.action_type`}
                    control={control}
                    isCustom={isCustom}
                  />
                </div>
                <div className={'absolute right-5 top-1/4'}>
                  <RemoveActionIcon
                    className={clsx(
                      'group',
                      fields.length > 1 ? 'cursor-pointer' : 'invisible pointer-events-none',
                    )}
                    onClick={() => removeAction(index)}
                  />
                </div>
              </div>
            )}
            <div className={'flex flex-col items-center'}>
              {WORKFLOWS_ACTION_MESSAGES_TYPES.includes(actionType) && (
                <Controller
                  control={control}
                  name={`action.${index}.action_message`}
                  render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <div className={'w-[84%]'}>
                      <Input
                        type={'text'}
                        className={'border-l-0 border-r-0 border-t-0 !rounded-none !px-3.5 !py-3'}
                        placeholder={'Type value'}
                        invalidMessage={error?.message}
                        value={value}
                        isValid={!error?.message}
                        onChange={onChange}
                      />
                    </div>
                  )}
                />
              )}
              {actionType === 'escalate' && (
                <WorkflowEscalatedList
                  isCustom={isCustom}
                  name={`action.${index}.action_escalated_list`}
                  control={control}
                  watch={watch}
                  trigger={trigger}
                  className={'w-[84%]'}
                />
              )}
            </div>
          </div>
        );
      })}
      {isCustom && fields.length < 2 && (
        <div>
          <Button
            onClick={addAction}
            variant="outline"
            className="flex items-center gap-1 min-h-[34px] min-w-[135px] mb-1"
          >
            <div className={'flex flex-row gap-2 items-center'}>
              <span className="font-semibold text-sm font-jamjuree text-[#7A6BE5CC]">
                Add Action
              </span>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                >
                  <path
                    d="M5.45 5.45V0.25H7.05V5.45H12.25V7.05H7.05V12.25H5.45V7.05H0.25V5.45H5.45Z"
                    fill="#7A6BE5"
                    stroke="#7A6BE5"
                    strokeWidth="0.5"
                  />
                </svg>
              </span>
            </div>
          </Button>
        </div>
      )}
    </div>
  );
};
